<template>
    <div class="login-register-dialog-root">
    <el-dialog
        :visible.sync="dialogVisible"
        :width="'400px'"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        modal-class="login-register-dialog-overlay"
        custom-class="login-register-dialog-panel"
        @close="closeDialog"
        class="login-register-dialog"
    >
        <div slot="title" class="dialog-title-wrap">
            <i class="el-icon-user dialog-title-icon"></i>
            <span>登录</span>
        </div>
        <div v-if="wxBindPhoneAfterLoginScan" class="login-handoff-bind">
            <p class="login-wx-tip">请填写<strong>手机号</strong>并完成短信验证，以将微信与账号绑定并登录。（若为新用户将同时完成注册）</p>
            <el-form label-width="100px" class="login-form register-form-full">
                <el-form-item v-if="registerWxNickname" label="微信昵称">
                    <span class="reg-wx-nick">{{ registerWxNickname }}</span>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="registerPhone" placeholder="请输入手机号" maxlength="11" show-word-limit clearable prefix-icon="el-icon-mobile-phone" autocomplete="tel" name="dbtool-register-phone"></el-input>
                </el-form-item>
                <el-form-item label="短信验证码">
                    <el-input v-model="registerCode" placeholder="输入短信码" maxlength="6" clearable prefix-icon="el-icon-message" autocomplete="off" name="dbtool-register-sms">
                        <el-button slot="append" type="primary" class="sms-code-btn" :disabled="smsCountdown > 0" @click="openSmsCaptchaGate('register')">
                            {{ smsCountdown > 0 ? smsCountdown + '秒后重发' : '获取验证码' }}
                        </el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="邀请码">
                    <el-input v-model="registerForm.inviteCode" placeholder="选填，填好友邀请码多获10金币" maxlength="20" clearable prefix-icon="el-icon-present" class="invite-code-input"></el-input>
                </el-form-item>
                <el-button type="text" class="reg-wx-back" @click="backFromWxBindPhone">返回微信扫码</el-button>
                <el-button type="primary" @click="doRegisterWechatComplete" style="width:100%" :loading="registerLoading" icon="el-icon-check">完成登录</el-button>
            </el-form>
        </div>
        <div v-else-if="loginAuthPanel === 'wxRegister'">
            <p v-if="registerWxStep === 0" class="login-wx-tip login-wx-tip--sub">新用户请完成以下步骤注册账号（需微信扫码关注公众号）。</p>
            <div v-show="registerWxStep === 0" class="reg-wx-panel">
                <p class="reg-wx-tip">请使用微信扫描下方二维码并关注公众号（用于验证身份）。</p>
                <div v-if="registerQrLoading" class="reg-wx-center"><i class="el-icon-loading"></i> 正在生成二维码…</div>
                <div v-else-if="registerQrError" class="reg-wx-err">{{ registerQrError }}</div>
                <div v-else-if="registerQrSrc" class="reg-wx-qr-wrap"><img class="reg-wx-qr" :src="registerQrSrc" alt="微信注册二维码"></div>
                <el-button type="primary" class="reg-wx-btn" @click="goRegisterStep(1)" :disabled="!registerSessionId || !!registerQrLoading || !!registerQrError">下一步</el-button>
                <el-button type="text" class="reg-wx-back" @click="switchToLoginPanel">返回登录</el-button>
            </div>
            <div v-show="registerWxStep === 1" class="reg-wx-panel">
                <p class="reg-wx-tip">请在微信中完成关注。系统将自动检测（约每 2 秒），也可手动刷新。若该微信已绑定过账号，将<strong>直接登录</strong>；新用户再点下一步绑定手机号。</p>
                <div v-if="registerQrSrc" class="reg-wx-qr-wrap reg-wx-qr-wrap--sm"><img class="reg-wx-qr" :src="registerQrSrc" alt="二维码"></div>
                <div v-if="registerWxAutoLoginLoading" class="reg-wx-center reg-wx-center--sm"><i class="el-icon-loading"></i> 正在验证并登录…</div>
                <div v-else-if="registerWxReady" class="reg-wx-ready"><i class="el-icon-success"></i> 已检测到关注；若未自动登录，请点击下一步绑定手机号</div>
                <div v-else class="reg-wx-wait">等待关注中…</div>
                <el-button size="small" class="reg-wx-btn" @click="pollRegisterStatusOnce">刷新状态</el-button>
                <el-button type="primary" class="reg-wx-btn" @click="goRegisterStep(2)" :disabled="!registerWxReady">下一步</el-button>
                <el-button type="text" class="reg-wx-back" @click="goRegisterStep(0)">上一步</el-button>
            </div>
            <div v-show="registerWxStep === 2">
                <el-form label-width="100px" class="login-form register-form-full">
                    <el-form-item v-if="registerWxNickname" label="微信昵称">
                        <span class="reg-wx-nick">{{ registerWxNickname }}</span>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <el-input v-model="registerPhone" placeholder="请输入手机号" maxlength="11" show-word-limit clearable prefix-icon="el-icon-mobile-phone" autocomplete="tel" name="dbtool-register-phone"></el-input>
                    </el-form-item>
                    <el-form-item label="短信验证码">
                        <el-input v-model="registerCode" placeholder="输入短信码" maxlength="6" clearable prefix-icon="el-icon-message" autocomplete="off" name="dbtool-register-sms">
                            <el-button slot="append" type="primary" class="sms-code-btn" :disabled="smsCountdown > 0" @click="openSmsCaptchaGate('register')">
                                {{ smsCountdown > 0 ? smsCountdown + '秒后重发' : '获取验证码' }}
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="邀请码">
                        <el-input v-model="registerForm.inviteCode" placeholder="选填，填好友邀请码多获10金币" maxlength="20" clearable prefix-icon="el-icon-present" class="invite-code-input"></el-input>
                    </el-form-item>
                    <el-button type="text" class="reg-wx-back" @click="goRegisterStep(1)">上一步</el-button>
                    <el-button type="primary" @click="doRegisterWechatComplete" style="width:100%" :loading="registerLoading" icon="el-icon-check">完成注册</el-button>
                </el-form>
            </div>
        </div>
        <div v-else class="login-main-panel">
                <div class="login-wx-panel">
                    <p class="login-wx-tip">请使用微信扫描下方<strong>公众号二维码</strong>。已注册用户将自动登录；若尚未注册，将引导您绑定手机号完成注册。</p>
                    <div v-if="loginWxQrLoading" class="login-wx-center"><i class="el-icon-loading"></i> 正在生成二维码…</div>
                    <div v-else-if="loginWxQrError" class="login-wx-err">{{ loginWxQrError }}</div>
                    <div v-else-if="loginWxQrSrc" class="login-wx-qr-wrap"><img class="login-wx-qr" :src="loginWxQrSrc" alt="公众号登录二维码"></div>
                    <div v-if="loginWxAutoLoginLoading" class="login-wx-center login-wx-center--sm"><i class="el-icon-loading"></i> 正在登录…</div>
                </div>
            <p class="login-footer-register-hint">还没有账号？<el-button type="text" class="login-footer-register-link" @click="openWxRegisterFlow">新用户注册</el-button></p>
        </div>
    </el-dialog>
    <el-dialog
        :visible.sync="smsCaptchaDialogVisible"
        title="安全验证"
        width="360px"
        center
        append-to-body
        custom-class="sms-captcha-gate-dialog"
        class="sms-captcha-gate-wrap"
        @close="onSmsGateDialogClose"
    >
        <p class="sms-gate-tip">请输入下方图形验证码，验证通过后将向您的手机发送短信验证码。</p>
        <div class="captcha-row sms-gate-captcha-row">
            <div class="captcha-code-box sms-gate-code-box" @click="refreshSmsGateCaptcha">{{ smsGateCaptchaCode || '点击换一张' }}</div>
            <el-input
                v-model="smsGateCaptchaInput"
                placeholder="图形验证码"
                maxlength="6"
                clearable
                class="captcha-input sms-gate-input"
                style="width:140px"
                autocomplete="off"
                name="dbtool-sms-gate-captcha"
                @keyup.enter.native="confirmSmsGateAndSend"
            ></el-input>
        </div>
        <span slot="footer" class="sms-gate-footer">
            <el-button @click="smsCaptchaDialogVisible = false">取 消</el-button>
            <el-button type="primary" :loading="smsGateLoading" @click="confirmSmsGateAndSend">确定并发送</el-button>
        </span>
    </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'LoginRegisterDialog',
    data() {
        return {
            loginForm: { username: '', password: '' },
            registerForm: { username: '', password: '', confirmPassword: '', captchaValue: '', inviteCode: '' },
            loginLoading: false,
            registerLoading: false,
            loginByPhone: false,
            loginPhone: '',
            loginCode: '',
            registerPhone: '',
            registerCode: '',
            captchaId: '',
            captchaCode: '',
            loginCaptchaId: '',
            loginCaptchaCode: '',
            loginCaptchaValue: '',
            smsCountdown: 0,
            smsCountdownTimer: null,
            registerWxStep: 0,
            registerQrLoading: false,
            registerQrError: '',
            registerQrSrc: '',
            registerSessionId: '',
            registerWxReady: false,
            registerWxNickname: '',
            registerPollTimer: null,
            /** 新用户注册向导：关注后尝试 session-login（与登录入口一致，已绑微信则直接进） */
            registerWxAutoLoginLoading: false,
            _registerWizardSessionLoginAttempted: false,
            loginWxByWechat: true,
            loginWxQrLoading: false,
            loginWxQrError: '',
            loginWxQrSrc: '',
            loginWxSessionId: '',
            loginWxPollTimer: null,
            loginWxAutoLoginLoading: false,
            /** 扫码登录后需验证手机（绑微信 / 新用户注册） */
            wxBindPhoneAfterLoginScan: false,
            /** 防止「立即轮询 + 定时轮询」两次都 ready 时重复调 session-login（第二次会 400 会话已使用） */
            _loginWxHandoffDone: false,
            smsCaptchaDialogVisible: false,
            smsCaptchaPurpose: 'login',
            smsGateCaptchaId: '',
            smsGateCaptchaCode: '',
            smsGateCaptchaInput: '',
            smsGateLoading: false
        }
    },
    computed: {
        dialogVisible: {
            get() { return this.$store.state.showLoginDialog },
            set(v) { this.$store.commit('SetShowLoginDialog', { show: !!v }) }
        },
        loginAuthPanel() {
            return this.$store.state.loginAuthPanel
        }
    },
    watch: {
        /** 密码登录与验证码登录切换时，同步 11 位手机号，避免重复输入 */
        loginByPhone(isSms) {
            const phoneRe = /^1\d{10}$/
            const u = (this.loginForm.username || '').trim()
            const p = (this.loginPhone || '').trim()
            if (isSms) {
                if (!p && phoneRe.test(u)) this.loginPhone = u
            } else {
                if (!u && phoneRe.test(p)) this.loginForm.username = p
                if (this.loginAuthPanel === 'login' && !this.loginWxByWechat && !this.wxBindPhoneAfterLoginScan) {
                    this.$nextTick(() => this.refreshLoginCaptcha())
                }
            }
        },
        loginAuthPanel(panel) {
            if (!this.dialogVisible) return
            if (panel === 'wxRegister') {
                this.initRegisterWizard()
                return
            }
            if (panel === 'login' && !this.wxBindPhoneAfterLoginScan) {
                this.$nextTick(() => {
                    if (this.loginWxByWechat) this.initLoginWechatFlow()
                    else if (!this.loginByPhone) this.refreshLoginCaptcha()
                })
            }
        },
        dialogVisible(visible) {
            if (visible && this.loginAuthPanel === 'login' && !this.wxBindPhoneAfterLoginScan) {
                this.$nextTick(() => {
                    if (this.loginWxByWechat) this.initLoginWechatFlow()
                    else if (!this.loginByPhone) this.refreshLoginCaptcha()
                })
            }
        },
        '$route.query.invite'(val) {
            if (val && (this.loginAuthPanel === 'wxRegister' || this.wxBindPhoneAfterLoginScan)) this.fillInviteFromRoute()
        }
    },
    beforeDestroy() {
        if (this.smsCountdownTimer) clearInterval(this.smsCountdownTimer)
        this.clearRegisterPoll()
        this.clearLoginWxPoll()
    },
    methods: {
        fillInviteFromRoute() {
            const invite = this.$route.query.invite
            if (invite && typeof invite === 'string') this.registerForm.inviteCode = invite.trim()
        },
        closeDialog() {
            this.clearRegisterPoll()
            this.clearLoginWxPoll()
            this._loginWxHandoffDone = false
            this.loginWxByWechat = true
            this.wxBindPhoneAfterLoginScan = false
            this.smsCaptchaDialogVisible = false
            this.smsGateCaptchaInput = ''
            this.smsGateCaptchaId = ''
            this.smsGateCaptchaCode = ''
            this.smsGateLoading = false
            this.registerWxAutoLoginLoading = false
            this._registerWizardSessionLoginAttempted = false
            this.$store.commit('SetShowLoginDialog', { show: false })
            if (this.smsCountdownTimer) {
                clearInterval(this.smsCountdownTimer)
                this.smsCountdownTimer = null
            }
            this.smsCountdown = 0
        },
        clearRegisterPoll() {
            if (this.registerPollTimer) {
                clearInterval(this.registerPollTimer)
                this.registerPollTimer = null
            }
        },
        clearLoginWxPoll() {
            if (this.loginWxPollTimer) {
                clearInterval(this.loginWxPollTimer)
                this.loginWxPollTimer = null
            }
        },
        switchToPhoneLogin() {
            this.clearLoginWxPoll()
            this.loginWxByWechat = false
            this.$nextTick(() => {
                if (!this.loginByPhone) this.refreshLoginCaptcha()
            })
        },
        switchToWechatLogin() {
            this.loginWxByWechat = true
            this.initLoginWechatFlow()
        },
        initLoginWechatFlow() {
            if (this.loginAuthPanel !== 'login' || this.wxBindPhoneAfterLoginScan) return
            this._loginWxHandoffDone = false
            this.clearLoginWxPoll()
            this.loginWxQrLoading = true
            this.loginWxQrError = ''
            this.loginWxQrSrc = ''
            this.loginWxSessionId = ''
            this.loginWxAutoLoginLoading = false
            this.$axios.post('/auth/wechat/register-session').then(res => {
                const d = res.data || {}
                if (d.sessionId && d.imageBase64) {
                    const mime = d.mimeType || 'image/jpeg'
                    this.loginWxSessionId = d.sessionId
                    this.loginWxQrSrc = 'data:' + mime + ';base64,' + d.imageBase64
                    this.startLoginWxPoll()
                } else {
                    this.loginWxQrError = d.message || '无法生成二维码'
                }
            }).catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message)
                    ? err.response.data.message
                    : '创建登录会话失败，请确认后端与数据库已就绪'
                this.loginWxQrError = msg
            }).finally(() => {
                this.loginWxQrLoading = false
            })
        },
        startLoginWxPoll() {
            this.clearLoginWxPoll()
            this.pollLoginWxStatusOnce()
            this.loginWxPollTimer = setInterval(() => this.pollLoginWxStatusOnce(), 2000)
        },
        pollLoginWxStatusOnce() {
            if (!this.loginWxSessionId || !this.loginWxByWechat) return
            if (this.loginAuthPanel !== 'login' || this.wxBindPhoneAfterLoginScan) return
            this.$axios.get('/auth/wechat/register-status', { params: { sessionId: this.loginWxSessionId } }).then(res => {
                const d = res.data || {}
                if (!d.success) return
                if (d.status === 'expired') {
                    this.loginWxQrError = '二维码已过期，请关闭弹窗后重新打开登录'
                    this.clearLoginWxPoll()
                    return
                }
                if (d.ready) {
                    if (this._loginWxHandoffDone) return
                    this._loginWxHandoffDone = true
                    this.clearLoginWxPoll()
                    this.tryWechatSessionLogin(d.nickname || '')
                }
            }).catch(() => {})
        },
        tryWechatSessionLogin(nicknameForRegister) {
            if (!this.loginWxSessionId) return
            this.loginWxAutoLoginLoading = true
            this.$axios.post('/auth/wechat/session-login', { sessionId: this.loginWxSessionId }, {
                validateStatus: (s) => s === 200 || s === 400
            }).then(res => {
                const data = res.data || {}
                if (res.status === 200 && data.token) {
                    const u = data.user || {}
                    this.$store.commit('SetUser', {
                        token: data.token,
                        username: u.username || '',
                        coins: u.coins != null ? u.coins : 0,
                        id: u.id
                    })
                    this.syncProfileAfterLogin()
                    this.dialogVisible = false
                    this.loginWxQrSrc = ''
                    this.loginWxSessionId = ''
                    this.$message({ message: '登录成功', type: 'success' })
                    return
                }
                if (data.code === 'WECHAT_SESSION_NEED_REGISTER') {
                    this.goToRegisterFromLoginWx(nicknameForRegister)
                    return
                }
                if (res.status === 400) {
                    this.$message({ message: data.message || '登录失败', type: 'warning' })
                    return
                }
                this.$message({ message: '登录失败，请稍后重试', type: 'warning' })
            }).catch(() => {
                this.$message({ message: '登录失败，请检查网络', type: 'warning' })
            }).finally(() => {
                this.loginWxAutoLoginLoading = false
            })
        },
        goToRegisterFromLoginWx(nickname) {
            this.clearLoginWxPoll()
            this.clearRegisterPoll()
            this.registerWxStep = 2
            this.registerSessionId = this.loginWxSessionId
            this.registerQrSrc = this.loginWxQrSrc
            this.registerWxReady = true
            this.registerWxNickname = nickname || ''
            this.registerQrError = ''
            this.registerQrLoading = false
            this.wxBindPhoneAfterLoginScan = true
            if (this.$store.state.loginAuthPanel !== 'login') {
                this.$store.commit('SetShowLoginDialog', { show: true, tab: 'login' })
            }
            this.fillInviteFromRoute()
            this.$nextTick(() => {
                this.$message({ message: '请验证手机号以完成微信绑定并登录', type: 'info' })
            })
        },
        openWxRegisterFlow() {
            this.wxBindPhoneAfterLoginScan = false
            this.loginWxByWechat = true
            this.clearRegisterPoll()
            this.$store.commit('SetShowLoginDialog', { show: true, tab: 'register' })
        },
        switchToLoginPanel() {
            this.clearRegisterPoll()
            this.registerWxStep = 0
            this.wxBindPhoneAfterLoginScan = false
            this.loginWxByWechat = true
            this.$store.commit('SetShowLoginDialog', { show: true, tab: 'login' })
        },
        backFromWxBindPhone() {
            this.wxBindPhoneAfterLoginScan = false
            this.registerWxStep = 0
            this.registerPhone = ''
            this.registerCode = ''
            this.clearRegisterPoll()
            this._loginWxHandoffDone = false
            this.loginWxByWechat = true
            this.$nextTick(() => this.initLoginWechatFlow())
        },
        initRegisterWizard() {
            this.clearRegisterPoll()
            this.registerWxStep = 0
            this.registerWxReady = false
            this.registerWxNickname = ''
            this.registerQrError = ''
            this.registerQrSrc = ''
            this.registerSessionId = ''
            this.registerWxAutoLoginLoading = false
            this._registerWizardSessionLoginAttempted = false
            this.fillInviteFromRoute()
            this.loadRegisterSessionQr()
        },
        loadRegisterSessionQr() {
            this.registerQrLoading = true
            this.registerQrError = ''
            this.registerQrSrc = ''
            this.registerSessionId = ''
            this.$axios.post('/auth/wechat/register-session').then(res => {
                const d = res.data || {}
                if (d.sessionId && d.imageBase64) {
                    const mime = d.mimeType || 'image/jpeg'
                    this.registerSessionId = d.sessionId
                    this.registerQrSrc = 'data:' + mime + ';base64,' + d.imageBase64
                } else {
                    this.registerQrError = d.message || '无法生成二维码'
                }
            }).catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message)
                    ? err.response.data.message
                    : '创建注册会话失败，请确认后端与数据库已就绪'
                this.registerQrError = msg
            }).finally(() => {
                this.registerQrLoading = false
            })
        },
        goRegisterStep(step) {
            this.registerWxStep = step
            if (step === 1) {
                this.startRegisterPoll()
            } else {
                this.clearRegisterPoll()
            }
        },
        startRegisterPoll() {
            this.clearRegisterPoll()
            this.registerWxReady = false
            this.pollRegisterStatusOnce()
            this.registerPollTimer = setInterval(() => this.pollRegisterStatusOnce(), 2000)
        },
        pollRegisterStatusOnce() {
            if (!this.registerSessionId) return
            this.$axios.get('/auth/wechat/register-status', { params: { sessionId: this.registerSessionId } }).then(res => {
                const d = res.data || {}
                if (!d.success) return
                if (d.status === 'expired') {
                    this.registerQrError = '二维码已过期，请关闭弹窗后重新打开注册'
                    this.clearRegisterPoll()
                    return
                }
                if (d.ready) {
                    this.registerWxReady = true
                    this.registerWxNickname = d.nickname || ''
                    if (!this._registerWizardSessionLoginAttempted) {
                        this.clearRegisterPoll()
                        this._registerWizardSessionLoginAttempted = true
                        this.tryRegisterWizardSessionLogin()
                    }
                }
            }).catch(() => {})
        },
        /** 与「登录」扫码同源：已绑 openid 则直接登录，否则走绑定手机 */
        tryRegisterWizardSessionLogin() {
            if (!this.registerSessionId || this.registerWxAutoLoginLoading) return
            this.registerWxAutoLoginLoading = true
            this.$axios.post('/auth/wechat/session-login', { sessionId: this.registerSessionId }, {
                validateStatus: (s) => s === 200 || s === 400
            }).then(res => {
                const data = res.data || {}
                if (res.status === 200 && data.token) {
                    const u = data.user || {}
                    this.$store.commit('SetUser', {
                        token: data.token,
                        username: u.username || '',
                        coins: u.coins != null ? u.coins : 0,
                        id: u.id
                    })
                    this.syncProfileAfterLogin()
                    this.dialogVisible = false
                    this.registerQrSrc = ''
                    this.registerSessionId = ''
                    this.$message({ message: '登录成功', type: 'success' })
                    return
                }
                if (data.code === 'WECHAT_SESSION_NEED_REGISTER') {
                    return
                }
                if (res.status === 400) {
                    this.$message({ message: data.message || '登录失败', type: 'warning' })
                } else {
                    this.$message({ message: '登录失败，请稍后重试', type: 'warning' })
                }
                this._registerWizardSessionLoginAttempted = false
                this.startRegisterPoll()
            }).catch(() => {
                this.$message({ message: '登录失败，请检查网络', type: 'warning' })
                this._registerWizardSessionLoginAttempted = false
                this.startRegisterPoll()
            }).finally(() => {
                this.registerWxAutoLoginLoading = false
            })
        },
        doRegisterWechatComplete() {
            const phone = (this.registerPhone || '').trim()
            const code = (this.registerCode || '').trim()
            if (!/^1[0-9]{10}$/.test(phone)) {
                this.$message({ message: '请输入正确的11位手机号', type: 'warning' })
                return
            }
            if (!code) {
                this.$message({ message: '请输入短信验证码', type: 'warning' })
                return
            }
            if (!this.registerSessionId) {
                this.$message({ message: '注册会话无效，请重新扫码', type: 'warning' })
                return
            }
            const inviteCode = (this.registerForm.inviteCode || '').trim()
            this.registerLoading = true
            this.$axios.post('/auth/wechat/register-complete', {
                sessionId: this.registerSessionId,
                phone,
                code,
                password: '',
                inviteCode
            }).then(res => {
                if (res.data && res.data.token) {
                    const user = res.data.user || {}
                    const coins = user.coins != null ? user.coins : 10
                    const u = user.username || phone
                    this.$store.commit('SetUser', { token: res.data.token, username: u, coins, id: user.id })
                    this.syncProfileAfterLogin()
                    this.dialogVisible = false
                    this.clearRegisterPoll()
                    this.registerForm = { username: '', password: '', confirmPassword: '', captchaValue: '', inviteCode: '' }
                    this.registerPhone = ''
                    this.registerCode = ''
                    this.captchaCode = ''
                    this.captchaId = ''
                    const okMsg = (res.data && res.data.message) || '注册成功'
                    this.$message({ message: okMsg, type: 'success' })
                } else {
                    this.$message({ message: (res.data && res.data.message) || '注册失败', type: 'warning' })
                }
            }).catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message)
                    ? err.response.data.message
                    : '注册失败'
                this.$message({ message: msg, type: 'warning' })
            }).finally(() => { this.registerLoading = false })
        },
        /** 登录/注册成功后拉取 profile，同步金币与是否隐藏「关注公众号赚金币」 */
        syncProfileAfterLogin() {
            const tok = this.$store.state.user && this.$store.state.user.token
            if (!tok) return
            this.$axios.get('/user/profile', { params: { token: tok } }).then(res => {
                if (res.data && res.data.coins != null) this.$store.commit('SetUserCoins', res.data.coins)
                if (res.data && res.data.hideFollowOfficialEarn != null) {
                    this.$store.commit('SetUserHideFollowOfficialEarn', !!res.data.hideFollowOfficialEarn)
                }
            }).catch(() => {})
        },
        refreshCaptcha() {
            this.$axios.get('/captcha', { params: { t: Date.now() } }).then(res => {
                if (res.data && res.data.id && res.data.code) {
                    this.captchaId = res.data.id
                    this.captchaCode = res.data.code
                    this.registerForm.captchaValue = ''
                }
            }).catch(() => {
                this.$message({ message: '获取图形验证码失败', type: 'warning' })
            })
        },
        refreshLoginCaptcha() {
            this.$axios.get('/captcha', { params: { t: Date.now() } }).then(res => {
                if (res.data && res.data.id && res.data.code) {
                    this.loginCaptchaId = res.data.id
                    this.loginCaptchaCode = res.data.code
                    this.loginCaptchaValue = ''
                }
            }).catch(() => {
                this.$message({ message: '获取图形验证码失败', type: 'warning' })
            })
        },
        refreshSmsGateCaptcha() {
            this.$axios.get('/captcha', { params: { t: Date.now() } }).then(res => {
                if (res.data && res.data.id && res.data.code) {
                    this.smsGateCaptchaId = res.data.id
                    this.smsGateCaptchaCode = res.data.code
                    this.smsGateCaptchaInput = ''
                }
            }).catch(() => {
                this.$message({ message: '获取图形验证码失败', type: 'warning' })
            })
        },
        openSmsCaptchaGate(purpose) {
            const phone = purpose === 'login'
                ? (this.loginPhone || '').trim()
                : (this.registerPhone || '').trim()
            if (!/^1\d{10}$/.test(phone)) {
                this.$message({ message: '请输入正确的11位手机号', type: 'warning' })
                return
            }
            this.smsCaptchaPurpose = purpose
            this.smsGateCaptchaInput = ''
            this.smsCaptchaDialogVisible = true
            this.$nextTick(() => this.refreshSmsGateCaptcha())
        },
        onSmsGateDialogClose() {
            this.smsGateCaptchaInput = ''
            this.smsGateLoading = false
        },
        startSmsCountdown() {
            this.smsCountdown = 60
            if (this.smsCountdownTimer) clearInterval(this.smsCountdownTimer)
            this.smsCountdownTimer = setInterval(() => {
                this.smsCountdown--
                if (this.smsCountdown <= 0 && this.smsCountdownTimer) {
                    clearInterval(this.smsCountdownTimer)
                    this.smsCountdownTimer = null
                }
            }, 1000)
        },
        confirmSmsGateAndSend() {
            if (!this.smsGateCaptchaId || !(this.smsGateCaptchaInput || '').trim()) {
                this.$message({ message: '请输入图形验证码', type: 'warning' })
                return
            }
            const purpose = this.smsCaptchaPurpose
            const phone = purpose === 'login'
                ? (this.loginPhone || '').trim()
                : (this.registerPhone || '').trim()
            if (!/^1\d{10}$/.test(phone)) {
                this.$message({ message: '请输入正确的11位手机号', type: 'warning' })
                return
            }
            const type = purpose === 'login' ? 'login' : 'register'
            this.smsGateLoading = true
            this.$axios.post('/user/sms/send', {
                phone,
                type,
                captchaId: this.smsGateCaptchaId,
                captchaValue: this.smsGateCaptchaInput.trim()
            }).then(res => {
                if (res.data && (res.data.success === true || res.data.code === 0)) {
                    this.$message({ message: '验证码已发送', type: 'success' })
                    this.smsCaptchaDialogVisible = false
                    this.smsGateCaptchaInput = ''
                    this.startSmsCountdown()
                    this.refreshSmsGateCaptcha()
                } else {
                    this.$message({ message: (res.data && res.data.message) || '发送失败', type: 'warning' })
                    this.refreshSmsGateCaptcha()
                }
            }).catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message)
                    ? err.response.data.message
                    : '发送失败，请检查图形验证码是否正确'
                this.$message({ message: msg, type: 'warning' })
                this.refreshSmsGateCaptcha()
            }).finally(() => { this.smsGateLoading = false })
        },
        doLoginByPhone() {
            const phone = (this.loginPhone || '').trim()
            const code = (this.loginCode || '').trim()
            if (!/^1\d{10}$/.test(phone)) {
                this.$message({ message: '请输入正确的11位手机号', type: 'warning' })
                return
            }
            if (!code) {
                this.$message({ message: '请输入验证码', type: 'warning' })
                return
            }
            this.loginLoading = true
            this.$axios.post('/user/login/phone', { phone, code }).then(res => {
                if (res.data && res.data.token) {
                    const u = res.data.user || {}
                    this.$store.commit('SetUser', { token: res.data.token, username: u.username || u.phone || phone, coins: u.coins != null ? u.coins : 0, id: u.id })
                    this.syncProfileAfterLogin()
                    this.dialogVisible = false
                    this.loginPhone = ''
                    this.loginCode = ''
                    this.loginCaptchaValue = ''
                    this.loginCaptchaCode = ''
                    this.loginCaptchaId = ''
                    if (res.data.message) {
                        this.$message({ message: res.data.message, type: 'success', duration: 5000 })
                    } else {
                        this.$message({ message: '登录成功', type: 'success' })
                    }
                } else {
                    this.$message({ message: (res.data && res.data.message) || '登录失败', type: 'warning' })
                }
            }).catch(err => {
                if (err.response && err.response.status === 404) {
                    this.$message({ message: '后端尚未开通手机验证码登录', type: 'info' })
                } else {
                    const msg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : '登录失败，请检查网络或联系管理员'
                    this.$message({ message: msg, type: 'warning' })
                }
            }).finally(() => { this.loginLoading = false })
        },
        doRegisterFull() {
            const { username, password, confirmPassword } = this.registerForm
            const u = (username || '').trim()
            const phone = (this.registerPhone || '').trim()
            const code = (this.registerCode || '').trim()
            if (!u) {
                this.$message({ message: '请输入用户名', type: 'warning' })
                return
            }
            if (!password) {
                this.$message({ message: '请输入密码', type: 'warning' })
                return
            }
            if (password !== confirmPassword) {
                this.$message({ message: '两次输入的密码不一致', type: 'warning' })
                return
            }
            if (!/^1\d{10}$/.test(phone)) {
                this.$message({ message: '请输入正确的11位手机号', type: 'warning' })
                return
            }
            if (!code) {
                this.$message({ message: '请输入短信验证码', type: 'warning' })
                return
            }
            this.registerLoading = true
            const inviteCode = (this.registerForm.inviteCode || '').trim()
            this.$axios.post('/user/register/full', { username: u, password, phone, code, inviteCode }).then(res => {
                if (res.data && res.data.token) {
                    const user = res.data.user || { username: u, coins: 10 }
                    const coins = user.coins != null ? user.coins : 10
                    const id = user.id != null ? user.id : (res.data.userId != null ? res.data.userId : res.data.user_id)
                    this.$store.commit('SetUser', { token: res.data.token, username: user.username || u, coins, id })
                    this.syncProfileAfterLogin()
                    this.dialogVisible = false
                    this.registerForm = { username: '', password: '', confirmPassword: '', captchaValue: '', inviteCode: '' }
                    this.registerPhone = ''
                    this.registerCode = ''
                    this.captchaCode = ''
                    this.captchaId = ''
                    this.$message({ message: coins >= 20 ? '注册成功，已赠送20金币（含邀请码奖励）' : '注册成功，已赠送10金币', type: 'success' })
                } else {
                    this.$message({ message: (res.data && res.data.message) || '注册失败', type: 'warning' })
                }
            }).catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : '注册失败，请检查网络或联系管理员'
                this.$message({ message: msg, type: 'warning' })
            }).finally(() => { this.registerLoading = false })
        },
        doLogin() {
            if (!this.loginForm.username || !this.loginForm.password) {
                this.$message({ message: '请输入用户名和密码', type: 'warning' })
                return
            }
            if (!this.loginCaptchaId || !(this.loginCaptchaValue || '').trim()) {
                this.$message({ message: '请输入图形验证码', type: 'warning' })
                return
            }
            this.loginLoading = true
            this.$axios.post('/user/login', {
                ...this.loginForm,
                captchaId: this.loginCaptchaId,
                captchaValue: this.loginCaptchaValue.trim()
            }).then(res => {
                if (res.data && res.data.token) {
                    const u = res.data.user || {}
                    this.$store.commit('SetUser', { token: res.data.token, username: u.username || this.loginForm.username, coins: u.coins != null ? u.coins : 0, id: u.id })
                    this.syncProfileAfterLogin()
                    this.dialogVisible = false
                    this.loginForm = { username: '', password: '' }
                    this.loginCaptchaValue = ''
                    this.loginCaptchaCode = ''
                    this.loginCaptchaId = ''
                    this.$message({ message: '登录成功', type: 'success' })
                } else {
                    this.$message({ message: (res.data && res.data.message) || '登录失败', type: 'warning' })
                }
            }).catch(err => {
                if (err.response && err.response.status === 404) {
                    this.$message({ message: '后端尚未开通登录接口，请先使用注册（本地体验）', type: 'info' })
                } else {
                    const msg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : '登录失败，请检查网络或联系管理员'
                    this.$message({ message: msg, type: 'warning' })
                }
            }).finally(() => { this.loginLoading = false })
        }
    }
}
</script>

<style lang="less" scoped>
.login-wx-panel { padding-top: 4px; }
.login-wx-tip { font-size: 13px; color: #606266; line-height: 1.55; margin-bottom: 14px; }
.login-wx-tip--sub { margin-bottom: 10px; }
.login-wx-tip strong { color: #303133; font-weight: 600; }
.login-handoff-bind { padding-top: 2px; }
.login-footer-register-hint {
    text-align: center;
    font-size: 13px;
    color: #909399;
    margin-top: 14px;
    line-height: 1.5;
}
::v-deep .login-footer-register-link.el-button--text {
    padding: 0 4px;
    vertical-align: baseline;
    font-size: 13px;
}
.login-main-panel { min-height: 0; }
.login-wx-center { text-align: center; padding: 20px; color: #909399; }
.login-wx-center--sm { padding: 12px; font-size: 13px; }
.login-wx-err { color: #f56c6c; font-size: 13px; text-align: center; padding: 12px; }
.login-wx-qr-wrap { text-align: center; margin-bottom: 6px; }
.login-wx-qr { max-width: 220px; width: 100%; display: inline-block; border-radius: 8px; border: 1px solid #ebeef5; }
.reg-wx-panel { padding-top: 4px; }
.reg-wx-tip { font-size: 13px; color: #606266; line-height: 1.5; margin-bottom: 12px; }
.reg-wx-center { text-align: center; padding: 24px; color: #909399; }
.reg-wx-center--sm { padding: 12px; font-size: 13px; }
.reg-wx-err { color: #f56c6c; font-size: 13px; text-align: center; padding: 16px; }
.reg-wx-qr-wrap { text-align: center; margin-bottom: 8px; }
.reg-wx-qr-wrap--sm .reg-wx-qr { max-width: 160px; }
.reg-wx-qr { max-width: 220px; width: 100%; display: inline-block; border-radius: 8px; border: 1px solid #ebeef5; }
.reg-wx-btn { width: 100%; margin-top: 8px; }
.reg-wx-back { display: block; margin: 8px auto 0; }
.reg-wx-ready { color: #67c23a; font-size: 14px; text-align: center; margin: 8px 0; }
.reg-wx-wait { color: #909399; font-size: 13px; text-align: center; margin: 8px 0; }
.reg-wx-nick { color: #303133; }
::v-deep .login-register-dialog .el-dialog__header { padding: 16px 20px 10px; }
::v-deep .login-register-dialog .el-dialog__body { padding: 10px 20px 20px; }
.dialog-title-wrap {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    .dialog-title-icon { font-size: 22px; margin-right: 8px; color: #409EFF; }
}
.login-form .el-form-item { margin-bottom: 18px; }
.login-form .el-button--primary { margin-top: 8px; }
.login-form .captcha-row,
.register-form-full .captcha-row { display: flex; align-items: center; gap: 10px; }
.login-form .captcha-code-box,
.register-form-full .captcha-code-box {
    width: 100px; height: 36px; line-height: 36px; text-align: center; font-size: 18px; font-weight: bold;
    letter-spacing: 4px; background: #f0f2f5; border: 1px solid #dcdfe6; border-radius: 4px;
    cursor: pointer; color: #303133; user-select: none;
}
.login-form .captcha-code-box:hover,
.register-form-full .captcha-code-box:hover { border-color: #409EFF; color: #409EFF; }
::v-deep .sms-code-btn.el-button { display: inline-flex; align-items: center; justify-content: center; padding: 0 15px; }
.register-form-full .invite-code-input { width: 100%; }
::v-deep .register-form-full .invite-code-input .el-input__inner { width: 100%; box-sizing: border-box; }
</style>

<!-- 暗黑模式适配 -->
<style lang="less">
.login-register-dialog-overlay {
    background: rgba(11, 18, 32, 0.22) !important;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.login-register-dialog-panel {
    border-radius: 22px;
    overflow: hidden;
    box-shadow: 0 28px 80px rgba(15, 23, 42, 0.18);
}

.login-register-dialog-panel .el-dialog__header {
    padding-top: 18px;
}

.login-register-dialog-panel .el-dialog__body {
    padding-bottom: 24px;
}

.dark-mode .login-register-dialog {
    .login-wx-tip { color: var(--text-regular); }
    .login-wx-tip strong { color: var(--text-primary); }
    .login-wx-qr { border-color: var(--border-color); }
    .dialog-title-wrap { color: var(--text-primary); }
    .captcha-code-box {
        background: var(--bg-secondary) !important;
        border-color: var(--border-color) !important;
        color: var(--text-primary) !important;
        &:hover { border-color: #409eff !important; color: #409eff !important; }
    }
}
.dark-mode .login-register-dialog .el-form-item__label { color: var(--text-regular); }
.dark-mode .login-register-dialog .login-footer-register-hint { color: var(--text-secondary); }
.dark-mode .login-register-dialog-panel {
    box-shadow: 0 28px 80px rgba(0, 0, 0, 0.42);
}
.dark-mode .login-register-dialog-overlay {
    background: rgba(3, 7, 18, 0.34) !important;
}
.sms-captcha-gate-dialog .sms-gate-tip {
    font-size: 13px;
    color: #606266;
    margin: 0 0 14px;
    line-height: 1.5;
}
.sms-captcha-gate-dialog .captcha-row {
    display: flex;
    align-items: center;
    gap: 10px;
}
.sms-captcha-gate-dialog .sms-gate-code-box {
    width: 100px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 4px;
    background: #f0f2f5;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    color: #303133;
    user-select: none;
}
.sms-captcha-gate-dialog .sms-gate-code-box:hover {
    border-color: #409eff;
    color: #409eff;
}
.dark-mode .sms-captcha-gate-dialog .sms-gate-tip { color: var(--text-regular); }
.dark-mode .sms-captcha-gate-dialog .sms-gate-code-box {
    background: var(--bg-secondary) !important;
    border-color: var(--border-color) !important;
    color: var(--text-primary) !important;
    &:hover { border-color: #409eff !important; color: #409eff !important; }
}
</style>
